<!-- src/views/videos/index.vue -->
<template>
    <div>
        Videos
    </div>
</template>

<script setup></script>

<style scoped></style>